document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.footer-logos-wrapper');
  let originalDivs = Array.from(wrapper.querySelectorAll('div')); // Gather original divs
  let images = originalDivs.map(div => div.querySelector('img')); // Store images separately

  function updateDivVisibility() {
    if (window.innerWidth < 820) {
      // On smaller screens, remove divs and leave only images
      if (originalDivs[0].parentNode === wrapper) { // Check if divs are still parented by wrapper
        images.forEach(img => {
          wrapper.appendChild(img); // Move each image out of its div and directly into the wrapper
        });
        originalDivs.forEach(div => div.remove()); // Remove divs from the DOM
      }
    } else {
      // On larger screens, re-wrap images with divs
      if (originalDivs[0].parentNode !== wrapper) { // Check if divs are not already in place
        images.forEach((img, index) => {
          let newDiv = document.createElement('div'); // Create a new div
          newDiv.appendChild(img); // Put the image back inside a div
          wrapper.appendChild(newDiv); // Append the new div to the wrapper
          originalDivs[index] = newDiv; // Update the originalDivs array with the new div
        });
      }
    }
  }

  window.addEventListener('resize', updateDivVisibility);
  updateDivVisibility(); // Execute function on initial load
});
